module.exports = __webpack_public_path__ + "static/img/mine_message@3x.ca62df7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mine_message@3x.png
// module id = JEpk
// module chunks = 1